module.exports = __webpack_public_path__ + "assets/img/ykzx.5bfbee6f.png";